// Parses datasetId, itemId and subsetId from a pathname like /dataset/:datasetId/item/:itemId/subset/:subsetId
export const getDatasetUrlParams = (
  pathname: string
): {
  datasetId: string | undefined;
  itemId: string | undefined;
  subsetId: string | undefined;
} => {
  const segments = pathname.split('/');
  const datasetIdx = segments.indexOf('dataset');
  const itemIdx = segments.indexOf('item');
  const subsetIdx = segments.indexOf('subset');

  return {
    datasetId: datasetIdx === -1 ? undefined : segments[datasetIdx + 1],
    itemId: itemIdx === -1 ? undefined : segments[itemIdx + 1],
    subsetId: subsetIdx === -1 ? undefined : segments[subsetIdx + 1],
  };
};
